import React from 'react';
import I18n from 'app/i18n';
import {CryptoIcon, GrowthIcon, RevshareIcon, StatsIcon} from './AffiliatesIcons';

const CARDS = [
    {icon: <RevshareIcon/>, text: 'w1p', title: 'w1h'},
    {icon: <StatsIcon/>, text: 'w2p', title: 'w2h'},
    {icon: <GrowthIcon/>, text: 'w3p', title: 'w3h'},
    {icon: <CryptoIcon/>, text: 'w4p', title: 'w4h'}
];

const AffiliatesWhy = (): React.ReactElement => <section className="sec sec-alt" id="why">
    <div className="wrap">
        <div className="sec-head rv">
            <div>
                <div className="eyebrow">{I18n.t('affiliate.why_ey')}</div>
                <h2 dangerouslySetInnerHTML={{__html: I18n.t('affiliate.why_h')}}/>
            </div>
        </div>
        <div className="cards4">
            {CARDS.map(card => <div className="wcard rv" key={card.title}>
                <div className="ico">{card.icon}</div>
                <h3>{I18n.t(`affiliate.${card.title}`)}</h3>
                <p>{I18n.t(`affiliate.${card.text}`)}</p>
            </div>)}
        </div>
    </div>
</section>;

export default AffiliatesWhy;
